import { ContextMsg } from "@/store/useChat";
import { MessageDto } from "@/types/message";
import { differenceInMinutes, parse } from "date-fns";

export const isRecentMsg = (msg: MessageDto | ContextMsg): boolean => {
    return differenceInMinutes(
        new Date(),
        typeof msg?.created_at === 'string' ?
            parse(
                msg.created_at,
                'yyyy-MM-dd HH:mm:ss X',
                new Date()
            )
        :
            msg?.created_at ?? new Date()
    ) <= 15;
}
